import React from "react";

/**
 * Site-wide Organization + WebSite JSON-LD.
 * Mount once in Layout so every page carries it.
 * Enables Google Knowledge Panel, sitelinks, and brand recognition.
 */
export function SiteSchemaJsonLd() {
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://tubedealer.com/#organization",
        name: "TubeDealer",
        url: "https://tubedealer.com",
        logo: {
          "@type": "ImageObject",
          url: "https://tubedealer.com/tubedealer-logo-hi.png",
        },
        description:
          "TubeDealer is a vacuum tube marketplace and dealer platform for modern production and vintage NOS tubes — import supplier CSVs, scan, identify, test, buy, and sell across multiple channels.",
      },
      {
        "@type": "WebSite",
        "@id": "https://tubedealer.com/#website",
        url: "https://tubedealer.com",
        name: "TubeDealer",
        publisher: { "@id": "https://tubedealer.com/#organization" },
        potentialAction: {
          "@type": "SearchAction",
          // The Browse page reads the "search" query parameter — keep this in
          // sync with the params.search assignment in Browse.tsx.
          target: {
            "@type": "EntryPoint",
            urlTemplate: "https://tubedealer.com/browse?search={search_term_string}",
          },
          "query-input": "required name=search_term_string",
        },
      },
    ],
  };

  const safeJson = JSON.stringify(schema)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026");

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: safeJson }}
    />
  );
}
